// Modules
import { ReactNode } from "react"

// Components
import { Td } from "~components/styled/table"
import SkeletonWrapper from "~components/SkeletonWrapper"

export interface LoadingTableProps {
  columns: number
  children?: ReactNode[] | ReactNode
  rowHeight: string
}

const LoadingTable = ({ columns, children, rowHeight }: LoadingTableProps) => {
  const rows: string[] = new Array(15).fill("")
  const cols: string[] = new Array(columns - (children?.length || 0)).fill("")

  return (
    <>
      {rows &&
        rows.map((_row, i) => (
          <tr key={i} style={{ height: rowHeight }}>
            {children}

            {cols.map((_col, j) => (
              <Td key={j}>
                <SkeletonWrapper isLoading={true} />
              </Td>
            ))}
          </tr>
        ))}
    </>
  )
}

export default LoadingTable
